var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-md" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 256 } },
              [
                _c("q-input", {
                  ref: "title",
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error,
                    disable: !_vm.manageWebcasts
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 1024 } },
              [
                _c("q-input", {
                  ref: "description",
                  attrs: {
                    type: "textarea",
                    "float-label": _vm.$t("description"),
                    error: _vm.$v.description.$error,
                    disable: !_vm.manageWebcasts
                  },
                  on: { input: _vm.$v.description.$touch },
                  model: {
                    value: _vm.description,
                    callback: function($$v) {
                      _vm.description = $$v
                    },
                    expression: "description"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm.isChevrolet
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-input", {
                  attrs: {
                    type: "text",
                    "float-label": _vm.$t("training_code"),
                    disable: !_vm.manageWebcasts
                  },
                  model: {
                    value: _vm.code,
                    callback: function($$v) {
                      _vm.code = $$v
                    },
                    expression: "code"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _vm.canSetProvider
              ? _c("q-select", {
                  attrs: {
                    options: _vm.getWebcastTypes,
                    "float-label": _vm.$t("stream_type"),
                    chips: "",
                    "autofocus-filter": "",
                    disable: !_vm.manageWebcasts
                  },
                  model: {
                    value: _vm.webcast_type,
                    callback: function($$v) {
                      _vm.webcast_type = $$v
                    },
                    expression: "webcast_type"
                  }
                })
              : _c("q-select", {
                  attrs: {
                    disable: "",
                    readonly: "",
                    filled: "",
                    hint: "Disable and readonly",
                    options: _vm.getWebcastTypes,
                    "float-label": _vm.$t("stream_type"),
                    chips: "",
                    "autofocus-filter": ""
                  },
                  model: {
                    value: _vm.webcast_type,
                    callback: function($$v) {
                      _vm.webcast_type = $$v
                    },
                    expression: "webcast_type"
                  }
                })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _vm.webcast_type !== 2
              ? _c("q-input", {
                  ref: "embed",
                  attrs: {
                    "float-label": _vm.$t("transmission_url"),
                    error: _vm.$v.embed.$error,
                    disable: !_vm.manageWebcasts
                  },
                  on: { input: _vm.$v.embed.$touch },
                  model: {
                    value: _vm.embed,
                    callback: function($$v) {
                      _vm.embed = $$v
                    },
                    expression: "embed"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm.selected_client_params.webcast_use_score
          ? _c(
              "div",
              {
                class: _vm.hasMinWatchTimePercentage
                  ? "col-xs-6 col-sm-6"
                  : "col-xs-12"
              },
              [
                !_vm.selected_client_params.webcast_use_static_score &&
                _vm.canSetScore
                  ? _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("score"),
                        type: "number",
                        disable: !_vm.manageWebcasts
                      },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e(),
                _vm.selected_client_params.webcast_use_static_score &&
                _vm.canSetScore
                  ? _c("q-select", {
                      attrs: {
                        options: _vm.scoresOptions,
                        "float-label": _vm.$t("score"),
                        disable: !_vm.manageWebcasts
                      },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.hasMinWatchTimePercentage
          ? _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      helper:
                        "" + _vm.$t("the_percentage_must_be_between_5_and_8")
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t(
                          "min_attendance_for_certification"
                        ),
                        type: "number",
                        disable:
                          !_vm.manageWebcasts ||
                          _vm.disableMinWatchTimePercentage ||
                          _vm.has_results,
                        error: _vm.$v.min_watch_time_percentage.$error
                      },
                      model: {
                        value: _vm.min_watch_time_percentage,
                        callback: function($$v) {
                          _vm.min_watch_time_percentage = $$v
                        },
                        expression: "min_watch_time_percentage"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("q-select", {
              ref: "timezone",
              attrs: {
                options: _vm.timezones,
                "float-label": _vm.$t("timezone"),
                filter: "",
                error: _vm.$v.timezone.$error,
                disable: !_vm.manageWebcasts
              },
              on: { input: _vm.$v.timezone.$touch },
              model: {
                value: _vm.timezone,
                callback: function($$v) {
                  _vm.timezone = $$v
                },
                expression: "timezone"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-6 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "transmission_date",
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("transmission_date"),
                format: "DD/MM/YYYY HH:mm",
                error: _vm.$v.transmission_date.$error,
                disable: !_vm.manageWebcasts
              },
              on: { input: _vm.$v.transmission_date.$touch },
              model: {
                value: _vm.transmission_date,
                callback: function($$v) {
                  _vm.transmission_date = $$v
                },
                expression: "transmission_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-6 col-sm-6" },
          [
            _c("q-input", {
              ref: "workload",
              attrs: {
                type: "number",
                "float-label": _vm.$t("workload_in_hours"),
                error: _vm.$v.workload.$error,
                disable: !_vm.manageWebcasts
              },
              on: { input: _vm.$v.workload.$touch },
              model: {
                value: _vm.workload,
                callback: function($$v) {
                  _vm.workload = $$v
                },
                expression: "workload"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("use_chat")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorUseChat,
                options: _vm.chat_options,
                disable: !_vm.manageWebcasts
              },
              model: {
                value: _vm.use_chat,
                callback: function($$v) {
                  _vm.use_chat = $$v
                },
                expression: "use_chat"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("chat_moderated")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorChatModerated,
                options: _vm.chat_options,
                disable: _vm.disableChatModerated || !_vm.manageWebcasts
              },
              model: {
                value: _vm.chat_moderated,
                callback: function($$v) {
                  _vm.chat_moderated = $$v
                },
                expression: "chat_moderated"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.optionTags,
                "float-label": _vm.$t("tags"),
                multiple: "",
                chips: "",
                filter: "",
                "autofocus-filter": "",
                disable: !_vm.manageWebcasts
              },
              model: {
                value: _vm.tag,
                callback: function($$v) {
                  _vm.tag = $$v
                },
                expression: "tag"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("image")))
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: true,
                    aspect_ratio: 52 / 29,
                    aspect_ratio_string: "52/29",
                    disable: !_vm.manageWebcasts
                  },
                  on: { fileUploaded: _vm.imageUploaded }
                }),
                _vm.webcast_images
                  ? _c(
                      "p",
                      { staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fas fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.webcast_images,
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$truncateLink(_vm.webcast_images))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c(
                "p",
                { staticClass: "caption" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("alt_image")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "far fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image_information_helper")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between" },
                [
                  _vm._l(_vm.languages, function(lang) {
                    return [
                      lang.code === "pt-br"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_br",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_br.$error
                                },
                                on: { input: _vm.$v.language_br.$touch },
                                model: {
                                  value: _vm.language_br,
                                  callback: function($$v) {
                                    _vm.language_br = $$v
                                  },
                                  expression: "language_br"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "en-us"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_us",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_us.$error
                                },
                                on: { input: _vm.$v.language_us.$touch },
                                model: {
                                  value: _vm.language_us,
                                  callback: function($$v) {
                                    _vm.language_us = $$v
                                  },
                                  expression: "language_us"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "es-es"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_es",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_es.$error
                                },
                                on: { input: _vm.$v.language_es.$touch },
                                model: {
                                  value: _vm.language_es,
                                  callback: function($$v) {
                                    _vm.language_es = $$v
                                  },
                                  expression: "language_es"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "fr-fr"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_fr",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_fr.$error
                                },
                                on: { input: _vm.$v.language_fr.$touch },
                                model: {
                                  value: _vm.language_fr,
                                  callback: function($$v) {
                                    _vm.language_fr = $$v
                                  },
                                  expression: "language_fr"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ]),
        _vm.webcast_lounge_templates_value.length > 0
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  attrs: {
                    chips: "",
                    options: _vm.webcast_lounge_templates_value.map(function(
                      e
                    ) {
                      return { value: e.id, label: e.title }
                    }),
                    "float-label": _vm.$t("webcast_lounge_template"),
                    clearable: ""
                  },
                  model: {
                    value: _vm.webcast_lounge_template,
                    callback: function($$v) {
                      _vm.webcast_lounge_template = $$v
                    },
                    expression: "webcast_lounge_template"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "q-field",
              { attrs: { helper: "" + _vm.$t("date_to_unpublish") } },
              [
                _c("q-datetime", {
                  ref: "unpublish_date",
                  attrs: {
                    type: "date",
                    "float-label": _vm.$t("unpublish_date"),
                    format: "DD/MM/YYYY",
                    clearable: "",
                    disable: !_vm.manageWebcasts
                  },
                  model: {
                    value: _vm.unpublish_date,
                    callback: function($$v) {
                      _vm.unpublish_date = $$v
                    },
                    expression: "unpublish_date"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fas fa-clipboard-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: {
                        val: true,
                        label: _vm.$t("select_all_areas"),
                        disable: !_vm.manageWebcasts
                      },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        filters: _vm.area,
                        options: _vm.areas,
                        error: _vm.$v.area.$error,
                        input: _vm.$v.area.$touch,
                        disable: !_vm.manageWebcasts
                      },
                      on: {
                        on_value: function($event) {
                          _vm.area = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable: !_vm.manageWebcasts
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profile",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error),
                                disable: !_vm.manageWebcasts
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            ref: "user_group",
                            attrs: {
                              options: _vm.user_groups,
                              "float-label": _vm.$t("groups"),
                              error: _vm.$v.user_group.$error,
                              multiple: "",
                              chips: "",
                              disable: !_vm.manageWebcasts
                            },
                            on: { input: _vm.$v.user_group.$touch },
                            model: {
                              value: _vm.user_group,
                              callback: function($$v) {
                                _vm.user_group = $$v
                              },
                              expression: "user_group"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm.id_webcast != 0
                    ? _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-11" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("link"),
                                disable: true
                              },
                              model: {
                                value: _vm.url_webcast_portal,
                                callback: function($$v) {
                                  _vm.url_webcast_portal = $$v
                                },
                                expression: "url_webcast_portal"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-1 q-mt-lg" },
                          [
                            _c(
                              "q-btn",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  dense: "",
                                  color: "primary",
                                  icon: "far fa-copy"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.copyLink()
                                  }
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("copy_link")) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses,
                disable: !_vm.manageWebcasts
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_webcasts" })
                }
              }
            })
          ],
          1
        ),
        _vm.showDuplicateButton
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "info",
                    label: _vm.$t("duplicate_webcast"),
                    icon: "far fa-copy"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_confirm_duplicate = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save",
                disable: !_vm.manageWebcasts
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.duplicateWebcast },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_confirm_duplicate = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("confirm") },
                    on: {
                      click: function($event) {
                        return _vm.duplicateWebcast()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_confirm_duplicate,
            callback: function($$v) {
              _vm.show_confirm_duplicate = $$v
            },
            expression: "show_confirm_duplicate"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("duplicate_webcast")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("confirm_duplicate_the_webcast_and_all_its_contents")
              )
            )
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.endWebcast()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_end = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("end") },
                    on: {
                      click: function($event) {
                        return _vm.endWebcast()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_end,
            callback: function($$v) {
              _vm.confirm_end = $$v
            },
            expression: "confirm_end"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("end_webcast")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_end_webcast")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }